<template>
  <el-row>
    <el-col :span="5">
      <basic-container>
        <div style="display: flex">
          <el-form>
          <el-form-item>
            <el-row>
              <el-col :span="6">项目名称</el-col>
              <el-col :span="18">
                <el-select v-model="form.projectId" placeholder="请选择项目" @change="changeSelectProject" >
                  <el-option
                    v-for="(item,index) in projectIdList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          </el-form>
        </div>
        <avue-tree :option="treeOption" :data="treeData" @node-click="nodeClick" @update="treeUpdate"
                   @save="saveNode" @del="delNode" v-model="treeForm"/>
      </basic-container>
    </el-col>
    <el-col :span="19">
      <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeValueTypeOpen"
                   v-model="form"
                   ref="crud"
                   @row-del="rowValueTypeDel"
                   @search-change="searchValueTypeChange"
                   @search-reset="searchValueTypeReset"
                   @selection-change="selectionValueTypeChange"
                   @current-change="currentValueTypeChange"
                   @size-change="sizeValueTypeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">

      <template slot-scope="scope" slot="analyseSort">
        {{getAnalyseSort(scope.row.analyseSort+'')}}
      </template>
                       <!-- v-if="permission.valueType_add" -->
          <template slot-scope="scope" slot="menuLeft">
            <el-button type="primary"
                       size="small"
                       icon="el-icon-plus"
                       @click="addValueTypeOpen">新 增
            </el-button>
          </template>
          <template slot="projectIdSearch">

          </template>
          <!-- <template slot-scope="scope" slot="menuLeft">
    <el-button type="danger" icon="el-icon-plus" size="small" plain @click.stop="handleAdd()">新增</el-button>
  </template> -->
          <!--自定义查看按钮-->
          <template slot-scope="{ row }" slot="menu">
            <el-button
              type="text"
              icon="el-icon-view"
              size="small"
              plain
              style="border: 0; background-color: transparent !important;"
              @click.stop="viewClick(row)"
            >查看
            </el-button>
            <el-button
              type="text"
              icon="el-icon-edit"
              size="small"
              plain
              style="border: 0; background-color: transparent !important;"
              @click.stop="editClick(row)"
            >编辑
            </el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              size="small"
              plain
              style="border: 0; background-color: transparent !important;"
              @click.stop="rowValueTypeDel(row)"
            >删除
            </el-button>
          </template>
        </avue-crud>
        <el-dialog title="新增" v-if="addDialogFormVisible" :visible.sync="addDialogFormVisible" append-to-body>
          <el-form :model="addForm" ref="addForm" :rules="rules">
            <el-form-item label="科目编号" prop="analyseCode" :label-width="formLabelWidth">
              <el-input size="small" v-model="addForm.analyseCode" maxlength="50" show-word-limit></el-input>
              <el-input size="small" v-model="addForm.parentId" v-show="false"></el-input>
            </el-form-item>
            <el-form-item label="科目" prop="analyseSubject" :label-width="formLabelWidth">
              <el-input size="small" v-model="addForm.analyseSubject" maxlength="50" show-word-limit></el-input>
              <el-input size="small" v-model="addForm.parentId" v-show="false"></el-input>
            </el-form-item>

            <el-form-item label="类型" prop="analyseSort" :label-width="formLabelWidth">
              <!-- <el-input v-model="addForm.analyseSort" maxlength="100"></el-input> -->
              <el-select size="small" style="width:100%" v-model="addForm.analyseSort">
                <el-option
                  v-for="(item,index) in vauleAnalyseSortList"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="说明" prop="analyseExplain" :label-width="formLabelWidth">
              <el-input type ="textarea" v-model="addForm.analyseExplain" maxlength="50" show-word-limit></el-input>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="cancleAddForm">取 消</el-button>
            <el-button size="small" type="submit" @click="handleValueTypeAdd('addForm')">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="编辑" v-if="editDialogFormVisible" :visible.sync="editDialogFormVisible" append-to-body>
          <el-form :model="editForm" ref="editForm" :rules="rules">

            <el-form-item label="科目编号" prop="analyseCode" :label-width="formLabelWidth">
              <el-input size="small" v-model="editForm.analyseCode" maxlength="50" show-word-limit></el-input>
              <el-input size="small" v-model="editForm.parentId" v-show="false"></el-input>
            </el-form-item>
            <el-form-item label="科目" prop="analyseSubject" :label-width="formLabelWidth">
              <el-input size="small" v-model="editForm.analyseSubject" maxlength="50" show-word-limit></el-input>
              <el-input size="small" v-model="editForm.parentId" v-show="false"></el-input>
            </el-form-item>
            <el-form-item  label="科目分类名称" prop="analyseParentName" :label-width="formLabelWidth" v-model="editForm.parentName">
            <el-select style="width:100%" size="small" placeholder="请选择"  v-model="editParentName" :value="editParentName">
                           <el-option class="option-style" :label="label" :value="value">
                               <el-tree
                               ref="tree"
                               :data="menuTreeData"
                               :props="defaultProps"
                               :node-key="defaultProps.value"
                               @node-click="handleNodeClick">
                               </el-tree>
                          </el-option>
                      </el-select>

            </el-form-item>
            <el-form-item label="类型" prop="analyseSort" :label-width="formLabelWidth">
              <!-- <el-input v-model="addForm.analyseSort" maxlength="100"></el-input> -->
              <el-select size="small" style="width:100%" v-model="editForm.analyseSort">
                <el-option
                  v-for="(item,index) in vauleAnalyseSortList"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="说明" prop="analyseExplain" :label-width="formLabelWidth">
              <el-input type ="textarea" size="small" v-model="editForm.analyseExplain" maxlength="50" show-word-limit></el-input>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="cancleEditForm">取 消</el-button>
            <el-button size="small" type="submit" @click="handleValueTypeEdit('editForm')">确 定</el-button>
          </div>
        </el-dialog>



        <el-dialog title="查看" v-if="viewDialogFormVisible" :visible.sync="viewDialogFormVisible" append-to-body>
          <el-row>
            <el-form :model="viewForm">
              <el-form-item label="科目编号" prop="analyseCode" :label-width="formLabelWidth">
                <el-input size="small" v-model="viewForm.analyseCode" disabled></el-input>
                <el-input size="small" v-model="viewForm.parentId" v-show="false"></el-input>
              </el-form-item>
              <el-form-item label="科目" prop="analyseSubject" :label-width="formLabelWidth">
                <el-input size="small" v-model="viewForm.analyseSubject" disabled></el-input>
              </el-form-item>
              <el-form-item  label="科目分类名称" prop="analyseParentName" :label-width="formLabelWidth" v-model="editForm.parentName">
                <el-select style="width:100%" size="small" disabled="true" placeholder="请选择"  v-model="editParentName" :value="editParentName">
                  <el-option class="option-style" :label="label" :value="value">
                    <el-tree
                      ref="tree"
                      :data="menuTreeData"
                      :props="defaultProps"
                      :node-key="defaultProps.value"
                      @node-click="handleNodeClick">
                    </el-tree>
                  </el-option>
                </el-select>

              </el-form-item>
              <el-form-item size="small" label="类型" prop="analyseSort" :label-width="formLabelWidth">
                <!--<el-input v-model="viewForm.ValueTypeTitle" readonly></el-input>-->
                <!-- <el-input v-model="viewForm.analyseSubject" readonly></el-input> -->
                <el-select style="width:100%" v-model="viewForm.analyseSort" disabled>
                  <el-option
                    v-for="(item,index) in vauleAnalyseSortList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="说明" prop="analyseExplain" :label-width="formLabelWidth">
                <el-input type ="textarea" v-model="viewForm.analyseExplain" disabled></el-input>
              </el-form-item>
            </el-form>
          </el-row>

          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="viewDialogFormVisible = false">关 闭</el-button>
          </div>
        </el-dialog>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
  import {
    getDetailList,
    getDetailDetail,
    removeDetail,
    addDetail,
    updateDetail,
    getMenuTree,
    getMenuLazyTree,
    removeMenu,
    addMenu,
    updateMenu,
    getDictionary,
    getValueTypeMenuList,
    menuTree,
    menuTreeDetail
  } from "@/api/crmedical/value/valuetypedetail";
  import {getProjectList} from "@/api/crmedical/project/project";
  import {mapGetters} from "vuex";

  export default {
    data() {
      let form = {};
      return {
        rules: {
          analyseCode: [
            {required: true, message: '请输入编号'},
            {min: 1, max: 50, message: '长度在 1 到 50 个字符'},
          ],
          analyseSubject: [
            {required: true, message: '请输入科目'},
            {min: 1, max: 50, message: '长度在 1 到 50 个字符'},
          ],
          analyseExplain: [
            {required: false, message: '请输入说明'},
            {min: 1, max: 50, message: '长度在 1 到 50 个字符'},
          ],
          analyseSort: [
            {required: true, message: '请选择类型'},
            // {min: 1, max: 50, message: '长度在 1 到 50 个字符'},
          ],
          analyseParentName: [
          ],
        },
        vauleAnalyseSortList:[],
        editForm:{},
        editDialogFormVisible:false,
        addDialogFormVisible: false,
        viewDialogFormVisible: false,
        checkDialogFormVisible: false,
        formLabelWidth: '100px',
        initTreeFlag: true,
        treeForm: {},
        form: form,
        addForm: {},
        viewForm: {},
        checkForm: {},
        query: {},
        loading: true,
        projectIdList: [],//项目下拉框
        editParentName:'',
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        menuTreeData:[],
        defaultProps: {
          value:'id',
          children: 'children',
          label: 'title'
        },
        treeDeptId: '',
        treeDeptName: '',
        parentName:'',
        treeData: [],
        treeOption: {
          nodeKey: 'id',
          addBtn: true,
          editBtn: true,
          delBtn: true,
          menu: true,
          lazy: true,
          // filter: false,
          treeLoad: function (node, resolve) {
            console.log();
            if (node.data.length != 0) {
              getMenuLazyTree(form.projectId,node.data.id).then(res => {
                resolve(res.data)
              });
            }
          },
          formOption: {
            labelWidth:150,
            column: [
              // {
              //   label: "上级类型",
              //   prop: "parentName",
              //   disabled: true,
              //   hide: true,
              //   type: 'input',
              //
              // },
              // {
              //   label: '权限',
              //   prop: 'menuPermission',
              //   type: 'select',
              //   dicUrl: '/api/blade-system/dict/dictionary?code=data_scope_type',
              //   props: {
              //     label: 'dictValue',
              //     value: 'dictKey',
              //   },
              //   dataType: 'number',
              //   rules: [{
              //     required: true,
              //     message: "请输入节点权限",
              //     trigger: "change"
              //   }]
              // }
            ],
          },
          props: {
            labelText: '分析类型名称',
            overHidden: true,
            label: 'title',
            value: 'value',
            children: 'children',
          }
        },

        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          indexLabel: '序号',
          index: true,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          viewBtn: false,
          selection: true,
          dialogClickModal: false,
          column: [
            {
              label: "科目编号",
              prop: "analyseCode",
              addDisplay: false,
              overHidden: true,
              search:true,
              rules: [
                {
                  required: false,
                  message: "请输入编号",
                  trigger: "change"
                }
              ]
            },
            {
              label: "科目",
              prop: "analyseSubject",
              addDisplay: false,
              overHidden: true,
              search:true,
              rules: [
                {
                  required: false,
                  message: "请输入编号",
                  trigger: "change"
                }
              ]
            },
            {
              label: "科目分类名称",
              prop: "parentId",
              dicData: [],
              props: { label: 'menuName', value: 'id' },
              addDisplay: false,
              viewDisplay: false,
              editDisplay: false,
            },
            {
              label: "说明",
              prop: "analyseExplain",
              overHidden: true,
              addDisplay: false,
              rules: [
                {
                  required: false,
                  message: "请输入标题",
                  trigger: "change"
                }
              ]
            },


            {
              label: "类型",
              prop: "analyseSort",
              type: "select",
              dicUrl: '/api/blade-system/dict/dictionary?code=vaule_analyse_sort',
              // search: true,
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              search:true,
              slot:true
              // hide: true,
              // addDisplay: false,
              // viewDisplay: false,
              // editDisplay: false,
            },




            // {
            //   label: "类型",
            //   prop: "analyseSort",
            //   addDisplay: false,
            //   overHidden: true,
            //   rules: [
            //     {
            //       required: false,
            //       message: "请输入类型",
            //       trigger: "change"
            //     }
            //   ]
            // },

          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.valueType_add, true),
          viewBtn: this.vaildData(this.permission.valuetypedetail_view, false),
          delBtn: this.vaildData(this.permission.valuetypedetail_delete, false),
          editBtn: this.vaildData(this.permission.valuetypedetail_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    created() {


      getDictionary({code:'vaule_analyse_sort'}).then((res)=>{
        this.vauleAnalyseSortList = res.data;

      });
      getProjectList().then((res) => {
        this.projectIdList = res.data;
        this.form.projectId = this.projectIdList[0].id;
        this.initData(this.projectIdList[0].id);
        this.query = {projectId:this.form.projectId,parentId:0}
        menuTree({projectId:this.form.projectId}).then((res) => {
          this.menuTreeData = res.data;
        });
        this.onLoad();
      });
    },
    methods: {
      // 切换选项
      handleNodeClick(node){
        console.log(node)
        this.editParentName = node[this.defaultProps.label];
        this.editForm.parentId = node[this.defaultProps.value];
      },
      getAnalyseSort(id){
        let name = '';
        this.vauleAnalyseSortList.forEach((ele,index)=>{
          if((id+'')===ele.dictKey){
            name = ele.dictValue;
          }
        });
        return name;
      },
      viewClick(row){
        this.viewForm = this.deepClone(row);
        this.viewForm.analyseSort = this.viewForm.analyseSort+'';
        menuTreeDetail({id:row.parentId}).then((res) => {
          this.editParentName = res.data.menuName
        });
        console.log(this.viewForm);
        this.viewDialogFormVisible = true;
      },
      editClick(row){
        this.editForm = this.deepClone(row);
        this.editForm.analyseSort = this.editForm.analyseSort+'';
        menuTreeDetail({id:row.parentId}).then((res) => {
          this.editParentName = res.data.menuName
        });


        console.log(this.editForm);
        this.editDialogFormVisible = true;
      },
      changeSelectProject(val){
        this.query.projectId = val;
        this.onLoad();
        menuTree({projectId:val}).then((res) => {
        this.menuTreeData = res.data;
        });
        this.form.projectId = val;
        this.treeDeptId = '';
          this.initData(val);
      },
      //树形菜单目录
      initData(projectId) {
        getMenuTree(projectId).then((res) => {
          this.treeData = res.data;
        });
      },

      saveNode(data, parent, done, loading) {
        if (parent.title.length > 50) {
          this.$message.warning('目录名称超出50字符长度!');
          // this.form.projectId = this.projectIdList[0].id;
          this.initData(this.form.projectId);
          // done();
          setTimeout(()=>{
              // this.$message.success('关闭按钮等待');
              loading();
            },100)
          return;
        }
        this.treeForm.projectId = this.form.projectId;
        this.treeForm.menuName = parent.title;
        this.treeForm.menuPermission = parent.menuPermission;
        if (data.id) {
          this.treeForm.parentId = data.id;
        }
        console.log(111111111,data.title)
        if (data.title) {

          this.treeForm.parentName = data.title;
          this.treeForm.parentMenuName = data.title;
        }
        addMenu(this.treeForm).then(() => {
          // this.form.projectId = this.projectIdList[0].id;
          this.initData(this.form.projectId);
          // this.initData();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
        this.treeForm = {};
      },

      treeUpdate(data, parent, done, loading) {
        if(data.id ==='0'){
          this.$message.warning('最顶级不允许修改!');
          done();
          return;
        }
        if (parent.title.length > 50) {
          this.$message.warning('分析类型超出50字符长度!');
          done();
          return;
        }
        this.treeForm.projectId = this.form.projectId;
        this.treeForm.menuName = parent.title;

        this.treeForm.id = data.id;
        updateMenu(this.treeForm).then(() => {
          this.initData(this.form.projectId);
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
        this.treeForm = {};
      },
      delNode(data, done) {
        if(data.id ==='0'){
          this.$message.warning('最顶级不允许删除!');
          done();
          this.initData(this.form.projectId);
          return;
        }
        this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (data.hasChildren) {
            this.$message.error('请删除节点以下的目录或文件!');
          } else {
            return removeMenu({ids: data.id}).then(() => {
              this.$message.success('操作成功!');
            });
          }
        }).then(() => {
          this.initData(this.form.projectId);
          this.treeForm = {};
          done();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      nodeClick(data) {

        this.treeDeptId = data.value;
        this.treeDeptName = data.title;
        this.treeForm.parentName = data.title;

        this.query.parentId = this.treeDeptId;
        this.query.projectId = this.form.projectId;
        this.onLoad();
      },
      beforeValueTypeOpen(done, type) {

        if (["edit", "view"].includes(type)) {
          getDetailDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchValueTypeReset() {
        this.query = {};
        this.query.projectId = this.form.projectId;
        this.query.parentId = this.treeDeptId;
        this.onLoad();
      },
      searchValueTypeChange(params, done) {
        this.query = params;
        // this.query.projectId = this.projectIdList[0].id;
        this.query.projectId = this.form.projectId;
        this.query.parentId = this.treeDeptId;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionValueTypeChange(list) {
        this.selectionList = list;
      },
      selectionValueTypeClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentValueTypeChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeValueTypeChange(pageSize) {
        this.page.pageSize = pageSize;
      },

      addValueTypeOpen() {
        if ('' === this.treeDeptId || null === this.treeDeptId) {
          this.$message.warning("请在左侧选择要添加的类型！");
          return;
        }
        let self = this;
        self.addForm.parentMenuName = this.treeDeptName;
        self.addForm.parentId = this.treeDeptId;
        self.addForm.projectId = this.form.projectId
        self.addDialogFormVisible = true;
      },
      handleValueTypeAdd(formName) {
        console.log(this.addForm);
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // this.addForm.ValueTypeAttachIds = this.attachIds.toString();
            addDetail(this.addForm).then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
              // this.attachIds = [];
              this.cancleAddForm();
            }, error => {
              // this.attachIds = [];
              window.console.log(error);
            });
          } else {
            // this.attachIds = [];
            console.log('请填写表单内容！');
            return false;
          }
        });
      },
      handleValueTypeEdit(formName) {
        console.log(this.editForm);
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // this.addForm.ValueTypeAttachIds = this.attachIds.toString();
            updateDetail(this.editForm).then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
              // this.attachIds = [];
              this.cancleEditForm();
            }, error => {
              // this.attachIds = [];
              window.console.log(error);
            });
          } else {
            // this.attachIds = [];
            console.log('请填写表单内容！');
            return false;
          }
        });
      },
      rowValueTypeDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return removeDetail({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      cancleAddForm() {
        this.addDialogFormVisible = false;
        this.addForm = {};
      },

      cancleEditForm() {
        this.editDialogFormVisible = false;
        this.editForm = {};
      },
      onLoad(page) {
        getValueTypeMenuList({projectId:this.query.projectId}).then(({ data }) => {
          this.findObject(this.option.column,'parentId').dicData = data;
        });
        page = page || this.page;
        this.loading = true;
        getDetailList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder=请选择项目]');
            ent.value = this.projectIdList[0].name;
            this.query.projectId = this.projectIdList[0].id;
            this.form.projectId = this.projectIdList[0].id;
            this.firstDisplayFlag = false;
          }
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          this.initData();
          this.selectionValueTypeClear();
        }).catch(err => {
          this.loading = false;
        })
      },
    }
  };
</script>

<style>
</style>
